// Base
import { BaseApi } from 'api/base.api';

// Interface

// Constant
import { ApiConstant } from 'constant';

// Utils
import { axios_renderUrl } from 'utils/axios';

// Interfaces
import { IAdditionalQuestionAPI, IAdditionalQuestionApiRequest, IAdditionalQuestionApiResponse, IGetAssesseeAdditionalQuestionAttrs, IGetPICAreaAdditionalQuestionAttrs, IUpdateAssesseeAdditionalQuestionAttrs } from 'interfaces/back-office/personal-data/additional-question';
import { IBaseApiRequestPayload } from 'interfaces/api';

export class AdditionalQuestionAPI extends BaseApi<IAdditionalQuestionAPI> implements IAdditionalQuestionApiRequest {
  readonly url = ApiConstant.ADDITIONAL_QUESTION;
  private additionalQuestionUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE);

  /**
   * @description Get additional-question as Assessee
   *
   * @method GET
   * @access private (only user that logged in)
   * 
   * @param {IGetAssesseeAdditionalQuestionAttrs} payload
   *
   * @return Promise<IAdditionalQuestionApiResponse>
   */
  async additionalQuestion_getAssesseeAdditionalQuestion(payload: IGetAssesseeAdditionalQuestionAttrs ): Promise<IAdditionalQuestionApiResponse> {
    try {
      const response = await this.GET(`${this.additionalQuestionUrl}/me`, {
        ...payload.requestConfig
      });
      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  /**
   * @description Update Additional-Question
   * @param {IUpdateAssesseeAdditionalQuestionAttrs}  payload 
   * @returns {Promise<any>} Promise<any>
   */
  async additionalQuestion_updateAssesseeAdditionalQuestion(payload: IUpdateAssesseeAdditionalQuestionAttrs): Promise<any> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: `${this.additionalQuestionUrl}/me`
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch(err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description get additional-question as PIC Area
   * 
   * @method GET
   * @access private (only user that logged in)
   * 
   * @param {IGetPICAreaAdditionalQuestionAttrs} payload
   * 
   * @return Promise<IAdditionalQuestionApiResponse>
   */
  async additionalQuestion_getPICAreaAdditionalQuestion(payload: IGetPICAreaAdditionalQuestionAttrs): Promise<IAdditionalQuestionApiResponse> {
    try {
        const response = await this.GET(`${this.additionalQuestionUrl}/${payload.params.userAccountId}`, {
          ...payload.requestConfig
        });
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
  }
}
